import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ArticuloService from "../../services/articulos";
import { OPERATION } from "../../helpers/enums";
import { CircularProgressCustom, VisorPDF } from "../../components";
import EtiquetaService from "../../services/etiquetas";

const Admin = ({ store }) => {
  const [loadingArticulos, setLoadingArticulos] = useState(false);
  const [etiquetasToPrint, setEtiquetasToPrint] = useState(null);

  const descargarEtiquetas = async (etiquetas) => {
    try {
      const response = await EtiquetaService.generate(etiquetas);

      console.log(response.data);

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // Abre el PDF en una nueva pestaña
      window.open(url, "_blank");

      // Opcional: Revocar la URL después de un tiempo
      setTimeout(() => window.URL.revokeObjectURL(url), 10000); // 10 segundos
    } catch (err) {
      alert("Hubo un problema al descargar el archivo");
      console.error(err);
    }
  };

  const loadArticulos = async () => {
    setLoadingArticulos(true)
    var resp = await ArticuloService.getAllArticlesInStoreTo(store._id, OPERATION.VENDER, false, 1, 999999)

    const range = resp?.reduce(
      (acc, item) => ({
        minPrice: Math.min(acc.minPrice, item.prices.sale_price),
        maxPrice: Math.max(acc.maxPrice, item.prices.sale_price),
      }),
      { minPrice: Infinity, maxPrice: -Infinity }
    );
    // setRangePrices(range)
    // setFilterValues({ name: '', category: '', rangePrices: [range?.minPrice, range?.maxPrice] })
    // setLoadsArticulos(false)
    setLoadingArticulos(false)
    return resp
  }

  // useEffect(() => {
  //   if (etiquetasToPrint) {
  //     descargarEtiquetas()
  //   }
  // }, [etiquetasToPrint])

  return <Box display='flex' justifyContent='center' flexDirection='column'>
    <Button
      onClick={async () => {
        var articlesToPrint = await loadArticulos()
        var articulos = []
        articlesToPrint.forEach(art =>
          articulos = [...articulos, ...(Array(art.quantity).fill(null).map(() => ({ ...art })))]
        );
        setEtiquetasToPrint(articlesToPrint)
        descargarEtiquetas(articulos)
      }}
    >Ver etiquetas</Button>
    {/* {etiquetasToPrint && <VisorPDF etiquetastoPrint={etiquetasToPrint} />} */}
    <Box display='flex' flexDirection='column' marginX='15px'>
      <br></br>
      {loadingArticulos ? <CircularProgressCustom /> : <Typography display='flex' variant='button' justifyContent='space-between'>
        <Box component='span'>Articulos en Stock</Box>
        <Box component='span'>{etiquetasToPrint?.reduce((acc, item) => acc + (item.quantity), 0)}</Box>
      </Typography>} 
    </Box>
  </Box>
}

export default Admin;